import {
  SAVE_USER_INFO,
  SAVE_COURSE_DATA,
  SAVE_COURSE_BUY_STATUS,
  SAVE_COURSE_BUY_STATUS_FOR_COURSE_LIST,
  SAVE_PRODUCT_SKU,
  SAVE_CURRENT_ENV,
  CHANGE_LOGIN_POPUP_STATUS,
  SAVE_USER_PHONE,
  SAVE_ALL_ACVITITY,
  SAVE_CURRICULUM_DATA,
  UPDATE_CURRENT_TIME,
  SAVE_COURSE_BASE_DATA,
  SAVE_ADDRESS_INFO,
  SET_CURRENT_YEAR,
  SAVE_ACTIONS_TYPE,
  SAVE_COURSE_INFO,
  SAVE_COURSE_SIMPLE_DATA,
  SAVE_GROUP_BUY_DETAIL,
  SET_ORDER_ADDRES,
  SET_COURSEDETAIL_CURRENTTIME
} from './mutations-type';

export default {
  saveUserInfo({ commit }, data) {
    commit(SAVE_USER_INFO, data);
  }, // 保存用户信息
  savCourseData({ commit }, data) {
    commit(SAVE_COURSE_DATA, data);
  }, // 保存课程基本数据
  saveCourseSimpleData({ commit }, data) {
    commit(SAVE_COURSE_SIMPLE_DATA, data);
  }, // 保存课程基本数据
  saveBuyStatus({ commit }, data) {
    commit(SAVE_COURSE_BUY_STATUS, data);
  }, // 保存课程购买状态
  saveBuyStatusForCourseList({ commit }, data) {
    commit(SAVE_COURSE_BUY_STATUS_FOR_COURSE_LIST, data);
  }, // 为判断课程列表是否可点击保存课程购买状态
  saveProductSku({ commit }, data) {
    commit(SAVE_PRODUCT_SKU, data);
  }, // 保存选中的sku
  saveCurrentEnv({ commit }, env) {
    commit(SAVE_CURRENT_ENV, env);
  }, // 保存当前环境
  changeLoginPopupStatus({ commit }, data) {
    commit(CHANGE_LOGIN_POPUP_STATUS, data);
  }, // 保存当前环境
  saveUserPhone({ commit }, data) {
    commit(SAVE_USER_PHONE, data);
  },
  saveAllAcvitity({ commit }, data) {
    commit(SAVE_ALL_ACVITITY, data);
  },
  // 保存课表
  saveCourseCurriculum({ commit }, data) {
    commit(SAVE_CURRICULUM_DATA, data);
  },
  updateCurrentTime({ commit }, data) {
    commit(UPDATE_CURRENT_TIME, data);
  },
  // 保存课程基本信息
  saveCourseBaseData({ commit }, data) {
    commit(SAVE_COURSE_BASE_DATA, data);
  },
  // 保存地址信息
  saveAddressInfo({ commit }, data) {
    commit(SAVE_ADDRESS_INFO, data);
  },
  // 设置考季
  setcurrentyear({ commit }, data) {
    commit(SET_CURRENT_YEAR, data);
  },
  set_actions_type({ commit }, data) {
    commit(SAVE_ACTIONS_TYPE, data);
  },
  save_course_info({ commit }, data) {
    commit(SAVE_COURSE_INFO, data);
  },
  // 拼团详情
  saveGroupBuyDetailVuex({ commit }, data) {
    commit(SAVE_GROUP_BUY_DETAIL, data);
  },
  // bilibili订单地址
  set_order_address({ commit }, data) {
    commit(SET_ORDER_ADDRES, data);
  },
  // 课程详情页服务器时间
  saveCourseDetailCurrentTime({ commit }, data) {
    commit(SET_COURSEDETAIL_CURRENTTIME, data);
  },
};
